import { EyeOutlined, LockOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import React from "react"

const { Title, Text } = Typography

interface GccOwnerLockOverlayProps {
  onTransferOwnership?: () => void
  onViewPermissions?: () => void
  hideActions?: boolean
}

export function GccOwnerLockOverlay({
  onTransferOwnership,
  onViewPermissions,
  hideActions
}: GccOwnerLockOverlayProps) {
  return (
    <div className="flex min-h-0 flex-1 items-center justify-center rounded-xl border border-border bg-white p-8 text-center">
      <div className="flex max-w-md flex-col items-center gap-4">
        <span className="flex size-14 items-center justify-center rounded-full bg-primary-bg text-primary">
          <LockOutlined aria-hidden style={{ fontSize: 26 }} />
        </span>
        <div className="flex flex-col gap-2">
          <Title level={4} className="m-0 text-xl font-semibold text-gray-900">
            GCC Owner permissions are protected
          </Title>
          <Text className="text-sm text-gray-500">
            Core permissions of the GCC Owner cannot be modified to prevent
            organization lockout.
            {!hideActions &&
              " To reassign this role, use the Transfer Ownership flow."}
          </Text>
        </div>
        {!hideActions && (
          <Flex gap={8} align="center" wrap justify="center">
            <Button type="primary" onClick={onTransferOwnership}>
              Transfer Ownership
            </Button>
            <Button icon={<EyeOutlined />} onClick={onViewPermissions}>
              View permissions
            </Button>
          </Flex>
        )}
      </div>
    </div>
  )
}
